import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import React from 'react';

type ModalUnsuspendProps = {
	onReactivate: () => void;
	onRevoke: () => void;
};

const ModalUnsuspendOption: React.FC<ModalUnsuspendProps> = (props) => {
	return (
		<>
			<Label>Firma Suspendida</Label>
			<Button variant="ghost" onClick={props.onReactivate}>
				Anular suspensión
			</Button>
			<Button variant="ghost" onClick={props.onRevoke}>
				Revocar
			</Button>
		</>
	);
};

export default ModalUnsuspendOption;
